import { Component, Input, HostBinding, input } from '@angular/core';

@Component({
    selector: 'sidenav-menu', // tslint:disable-line
    template: `
<a href="#" class="sidenav-link sidenav-toggle" [ngClass]="linkClass()">
  @if (icon) {
    <i class="sidenav-icon" [ngClass]="icon"></i>
  }
  <div [innerHTML]="text()"></div>
  @if (badge) {
    <div class="ms-auto pl-1"><div class="badge" [ngClass]="badgeClass()">{{badge}}</div></div>
  }
</a>
<div class="sidenav-menu">
  <ng-content></ng-content>
</div>
`,
    standalone: false
})
export class SidenavMenuComponent {
  @HostBinding('class.sidenav-item') hostClassMain = true;
  @HostBinding('class.d-block') hostClassBlock = true;

  readonly text = input('');
  @Input() icon = '';
  readonly linkClass = input('');
  @Input() badge: any = null;
  readonly badgeClass = input('');
  @Input() @HostBinding('class.disabled') disabled = false;
  @Input() @HostBinding('class.active') active = false;
  @Input() @HostBinding('class.open') open = false;
}
